import axios from 'axios'

import { getEpsBaseUrl } from './eps-base-url'

export type PersonExchangeCredentials = {
  idToken: string
  accessToken: string
  refreshToken: string
  expiration: number
  firstname: string
  lastname: string
  username: string
  personPublicKey: string
  userRole: string
}

/**
 * Cognito token exchange for multi-employer employer switch.
 * POST api/v1/auth/person-exchange
 * Returns a login-credential-shaped blob (see @hixme/auth-ui `loginUserSuccess`).
 */
export const exchangePerson = async (personId: string): Promise<PersonExchangeCredentials> => {
  const baseURL = getEpsBaseUrl()
  const response = await axios.post<PersonExchangeCredentials>(
    'api/v1/auth/person-exchange',
    { personId },
    { baseURL }
  )
  return response.data
}
